


// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import ReactPaginate from "react-paginate";
// import { FaGamepad, FaWallet, FaGift, FaExclamationTriangle, FaChevronRight } from "react-icons/fa";
// import Invoice from "./Invoice";
// import Spinner from "react-bootstrap/Spinner";
// import { Button } from "@mui/material";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import Header from "../Components/Header";

// const Transactionhistory = () => {
//   const printRef = useRef(null);
//   const [show, setShow] = useState(false);
//   const [invoiceData, setInvoiceData] = useState({});
//   const [user, setUser] = useState({});
//   const [activeTab, setActiveTab] = useState("Wallet");
//   const [walletData, setWalletData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [walletPages, setWalletPages] = useState(0);
//   const [gameData, setGameData] = useState([]);
//   const [gamePages, setGamePages] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);
//   const [pageNumber, setPageNumber] = useState(0);
//   const limit = 50;

//   const handleClose = () => setShow(false);
//   const handleShow = (data) => {
//     setInvoiceData(data);
//     setShow(true);
//   };

//   const pageprint = () => {
//     let divToPrint = printRef.current;
//     let htmlToPrint = `
//       <style>
//         .invoice { width: 100%; }
//         table, td, th { border: 1px solid black; border-collapse: collapse; }
//         td, th { padding: 8px; }
//       </style>
//     `;
//     htmlToPrint += divToPrint.outerHTML;
//     let newWin = window.open("");
//     newWin.document.write(htmlToPrint);
//     newWin.print();
//     newWin.close();
//   };

//   const dateFormat = (e) => {
//     const date = new Date(e);
//     return date.toLocaleString("default", {
//       month: "short",
//       day: "numeric",
//       hour: "numeric",
//       hour12: true,
//       minute: "numeric",
//     });
//   };

//   const fetchUser = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       const res = await axios.get(`https://api.rrludo.in/me`, { headers });
//       setUser(res.data);
//       fetchWalletData(res.data._id, pageNumber);
//       fetchGameData(res.data._id, pageNumber);
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   const fetchWalletData = async (id, page) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     const res = await axios.get(
//       `https://api.rrludo.in/temp/deposite/${id}?page=${page}&_limit=${limit}`,
//       { headers }
//     );
//     setWalletData(res.data.ress);
//     setWalletPages(res.data.totalPages);
//   };

//   const fetchGameData = async (id, page) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     setIsLoading(true);
//     const res = await axios.get(
//       `https://api.rrludo.in/game/history/user/${id}?page=${page}&_limit=${limit}`,
//       { headers }
//     );
//     const validGames = res.data.data.filter(
//       (g) => g.Status === "completed" || g.Status === "cancelled" || g.Status === "conflict"
//     );
//     setGameData(validGames);
//     setGamePages(res.data.totalPages);
//     setIsLoading(false);
//   };

//   useEffect(() => {
//     fetchUser();
//   }, [pageNumber]);

//   useEffect(() => {
//     if (activeTab === "Wallet") {
//       setFilteredData(walletData.filter((c) => c.Req_type === "deposit" || c.Req_type === "withdraw"));
//     } else if (activeTab === "Penalty") {
//       setFilteredData(walletData.filter((c) => c.Req_type === "penalty"));
//     } else if (activeTab === "Bonus") {
//       setFilteredData(walletData.filter((c) => c.Req_type === "bonus"));
//     }
//   }, [activeTab, walletData]);

//   const handlePageClick = (data) => setPageNumber(data.selected);

//   const handleSupport = (gameId) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${access_token}` };
//     const params = new URLSearchParams();
//     params.append("agent_id", "63b5340bc5d2b82e4652b216");
//     params.append("supportType", "game");
//     params.append("issue", gameId);
//     fetch("https://api.rrludo.in/chat/genrate-ticket", {
//       method: "POST",
//       headers,
//       body: params,
//     }).catch(console.error);
//   };

//   // --- UI THEME STYLES ---
//   const styles = {
//     mainBg: {
//       background: "radial-gradient(circle at top, #1a1a1a, #0a0a0a)",
//       minHeight: "100vh",
//       // paddingTop: "80px",
//       fontFamily: "'Inter', sans-serif",
//       color: "#fff",
//     },
//     tabContainer: {
//       display: "flex",
//       justifyContent: "space-around",
//       background: "#161616",
//       padding: "8px",
//       borderRadius: "15px",
//       marginBottom: "25px",
//       border: "1px solid #222",
//     },
//     tabButton: (isActive) => ({
//       flex: 1,
//       padding: "10px",
//       borderRadius: "12px",
//       border: "none",
//       background: isActive ? "linear-gradient(180deg, #FF3131 0%, #BA0000 100%)" : "transparent",
//       color: isActive ? "#fff" : "#888",
//       fontWeight: "700",
//       fontSize: "13px",
//       transition: "0.3s",
//       textTransform: "uppercase",
//     }),
//     card: {
//       background: "rgba(30, 30, 30, 0.6)",
//       backdropFilter: "blur(10px)",
//       borderRadius: "20px",
//       border: "1px solid rgba(255, 255, 255, 0.05)",
//       padding: "15px",
//       marginBottom: "15px",
//       transition: "0.3s",
//     },
//     statusBadge: (color) => ({
//       fontSize: "10px",
//       fontWeight: "800",
//       padding: "4px 10px",
//       borderRadius: "6px",
//       background: `${color}15`,
//       color: color,
//       border: `1px solid ${color}33`,
//       textTransform: "uppercase",
//     }),
//     amount: (isPositive) => ({
//       fontSize: "18px",
//       fontWeight: "800",
//       color: isPositive ? "#4CAF50" : "#FF3131",
//     }),
//     iconBg: (color) => ({
//         width: '40px',
//         height: '40px',
//         borderRadius: '12px',
//         background: `${color}10`,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         color: color
//     })
//   };

//   return (
//     <>
//       <Header user={user} />
//       <div style={styles.mainBg}>
//         <div className="container Orher_page_main_section">
//           <div className="row justify-content-center">
//             <div className="col-lg-7 col-md-12">
              
//               <h4 className="fw-bold mb-4 text-center">Activity History</h4>

//               {/* ==== Premium Tabs ==== */}
//               <div style={styles.tabContainer}>
//                 {["Wallet", "Game", "Penalty", "Bonus"].map((tab) => (
//                   <button
//                     key={tab}
//                     style={styles.tabButton(activeTab === tab)}
//                     onClick={() => {
//                       setActiveTab(tab);
//                       setPageNumber(0);
//                     }}
//                   >
//                     {tab}
//                   </button>
//                 ))}
//               </div>

//               {/* ==== Content Section ==== */}
//               {isLoading ? (
//                 <div className="text-center py-5">
//                   <Spinner animation="border" variant="danger" />
//                   <p className="mt-3 text-muted">Fetching your history...</p>
//                 </div>
//               ) : (
//                 <div className="pb-5">
//                   {/* WALLET / BONUS / PENALTY RENDER */}
//                   {activeTab !== "Game" && (
//                     filteredData.length > 0 ? (
//                       filteredData.map((item) => {
//                         const isPositive = item.Req_type === "deposit" || item.Req_type === "bonus";
//                         const statusColor = item.status === "PAID" ? "#4CAF50" : item.status === "Pending" ? "#FFC107" : "#FF3131";
//                         const typeIcon = item.Req_type === "deposit" ? <FaWallet/> : item.Req_type === "withdraw" ? <FaWallet/> : item.Req_type === "penalty" ? <FaExclamationTriangle/> : <FaGift/>;

//                         return (
//                           <div style={styles.card} key={item._id}>
//                             <div className="d-flex align-items-center justify-content-between mb-3">
//                               <div className="d-flex align-items-center gap-3">
//                                 <div style={styles.iconBg(statusColor)}>{typeIcon}</div>
//                                 <div>
//                                     <h6 className="mb-0 fw-bold text-uppercase" style={{fontSize: '14px'}}>{item.Req_type}</h6>
//                                     <small className="text-muted">{dateFormat(item.createdAt)}</small>
//                                 </div>
//                               </div>
//                               <div className="text-end">
//                                 <div style={styles.amount(isPositive)}>
//                                     {isPositive ? "+" : "-"} ₹{item.amount}
//                                 </div>
//                                 <div style={styles.statusBadge(statusColor)}>{item.status}</div>
//                               </div>
//                             </div>
//                             <div className="d-flex justify-content-between pt-2 border-top border-secondary opacity-75">
//                                 <small className="text-muted">Balance: ₹{item.closing_balance || "0"}</small>
//                                 <small className="text-muted">ID: #{item._id.slice(-6).toUpperCase()}</small>
//                             </div>
//                             {item.reason && <p className="small mt-2 mb-0 text-info">ℹ {item.reason}</p>}
//                           </div>
//                         );
//                       })
//                     ) : (
//                       <div className="text-center py-5 opacity-50">
//                         <img src="/images/notransactionhistory.png" width="180" alt="empty" />
//                         <p className="mt-3">No {activeTab} records found</p>
//                       </div>
//                     )
//                   )}

//                   {/* GAME HISTORY RENDER */}
//                   {activeTab === "Game" && (
//                     gameData.length > 0 ? (
//                       gameData.map((game) => {
//                         const isWin = game.Winner?._id === user._id;
//                         const statusColor = isWin ? "#4CAF50" : "#FF3131";

//                         return (
//                           <div style={styles.card} key={game._id}>
//                             <div className="d-flex align-items-center justify-content-between mb-3">
//                               <div className="d-flex align-items-center gap-3">
//                                 <div style={styles.iconBg(statusColor)}><FaGamepad size={20}/></div>
//                                 <div>
//                                     <h6 className="mb-0 fw-bold">{isWin ? "WIN" : "LOSS"}</h6>
//                                     <small className="text-muted">{dateFormat(game.createdAt)}</small>
//                                 </div>
//                               </div>
//                               <div className="text-end">
//                                 <div style={styles.amount(isWin)}>
//                                     {isWin ? "+" : "-"} ₹{isWin ? game.winnAmount : game.Game_Ammount}
//                                 </div>
//                                 <div style={styles.statusBadge(statusColor)}>{game.Status}</div>
//                               </div>
//                             </div>
                            
//                             <div className="p-2 rounded bg-black bg-opacity-25 d-flex justify-content-between align-items-center">
//                                 <div className="small">
//                                     <span className="text-muted">Opponent: </span>
//                                     <span className="fw-bold">{game.Accepetd_By && game.Accepetd_By._id === user._id ? game?.Created_by?.Name : game?.Accepetd_By?.Name}</span>
//                                 </div>
//                                 <Button
//                                     size="small"
//                                     onClick={() => handleSupport(game?._id)}
//                                     style={{ color: "#FF3131", fontSize: "11px", minWidth: 'auto' }}
//                                     startIcon={<SupportAgentIcon style={{fontSize: '16px'}} />}
//                                 >
//                                     Report
//                                 </Button>
//                             </div>
//                           </div>
//                         );
//                       })
//                     ) : (
//                       <div className="text-center py-5 opacity-50">
//                         <img src="/images/nogamehistory.png" width="180" alt="empty" />
//                         <p className="mt-3">No game history available</p>
//                       </div>
//                     )
//                   )}
//                 </div>
//               )}

//               {/* ==== PAGINATION ==== */}
//               {(activeTab === "Game" ? gamePages : walletPages) > 1 && (
//                 <div className="premium-pagination d-flex justify-content-center mt-2 mb-5">
//                   <ReactPaginate
//                     previousLabel={"←"}
//                     nextLabel={"→"}
//                     breakLabel={"..."}
//                     pageCount={activeTab === "Game" ? gamePages : walletPages}
//                     onPageChange={handlePageClick}
//                     containerClassName={"pagination-container"}
//                     activeClassName={"active-page"}
//                   />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <Invoice
//         pageprint={pageprint}
//         handleClose={handleClose}
//         show={show}
//         printRef={printRef}
//         invoice_data={invoiceData}
//       />

//       <style>{`
//         .pagination-container {
//             display: flex;
//             list-style: none;
//             gap: 8px;
//             padding: 0;
//         }
//         .pagination-container li a {
//             background: #1e1e1e;
//             color: #fff;
//             padding: 8px 14px;
//             border-radius: 8px;
//             text-decoration: none;
//             font-weight: 700;
//             border: 1px solid #333;
//             cursor: pointer;
//         }
//         .active-page a {
//             background: linear-gradient(180deg, #FF3131 0%, #BA0000 100%) !important;
//             border-color: transparent !important;
//         }
//         .pagination-container li.disabled a {
//             opacity: 0.3;
//             cursor: not-allowed;
//         }
//       `}</style>
//     </>
//   );
// };

// export default Transactionhistory;

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { FaGamepad, FaWallet, FaGift, FaExclamationTriangle, FaChevronRight, FaArrowUp, FaArrowDown } from "react-icons/fa";
import Invoice from "./Invoice";
import Spinner from "react-bootstrap/Spinner";
import { Button } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import Header from "../Components/Header";

const Transactionhistory = () => {
  const printRef = useRef(null);
  const [show, setShow] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [user, setUser] = useState({});
  const [activeTab, setActiveTab] = useState("Wallet");
  const [walletData, setWalletData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [walletPages, setWalletPages] = useState(0);
  const [gameData, setGameData] = useState([]);
  const [gamePages, setGamePages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const limit = 50;

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setInvoiceData(data);
    setShow(true);
  };

  const pageprint = () => {
    let divToPrint = printRef.current;
    let htmlToPrint = `
      <style>
        .invoice { width: 100%; }
        table, td, th { border: 1px solid black; border-collapse: collapse; }
        td, th { padding: 8px; }
      </style>
    `;
    htmlToPrint += divToPrint.outerHTML;
    let newWin = window.open("");
    newWin.document.write(htmlToPrint);
    newWin.print();
    newWin.close();
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    return date.toLocaleString("default", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
  };

  const fetchUser = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await axios.get(`https://api.rrludo.in/me`, { headers });
      setUser(res.data);
      fetchWalletData(res.data._id, pageNumber);
      fetchGameData(res.data._id, pageNumber);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchWalletData = async (id, page) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const res = await axios.get(
      `https://api.rrludo.in/temp/deposite/${id}?page=${page}&_limit=${limit}`,
      { headers }
    );
    setWalletData(res.data.ress);
    setWalletPages(res.data.totalPages);
  };

  const fetchGameData = async (id, page) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    setIsLoading(true);
    const res = await axios.get(
      `https://api.rrludo.in/game/history/user/${id}?page=${page}&_limit=${limit}`,
      { headers }
    );
    const validGames = res.data.data.filter(
      (g) => g.Status === "completed" || g.Status === "cancelled" || g.Status === "conflict"
    );
    setGameData(validGames);
    setGamePages(res.data.totalPages);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchUser();
  }, [pageNumber]);

  useEffect(() => {
    if (activeTab === "Wallet") {
      setFilteredData(walletData.filter((c) => c.Req_type === "deposit" || c.Req_type === "withdraw"));
    } else if (activeTab === "Penalty") {
      setFilteredData(walletData.filter((c) => c.Req_type === "penalty"));
    } else if (activeTab === "Bonus") {
      setFilteredData(walletData.filter((c) => c.Req_type === "bonus"));
    }
  }, [activeTab, walletData]);

  const handlePageClick = (data) => setPageNumber(data.selected);

  const handleSupport = (gameId) => {
    const access_token = localStorage.getItem("token");
    const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${access_token}` };
    const params = new URLSearchParams();
    params.append("agent_id", "63b5340bc5d2b82e4652b216");
    params.append("supportType", "game");
    params.append("issue", gameId);
    fetch("https://api.rrludo.in/chat/genrate-ticket", {
      method: "POST",
      headers,
      body: params,
    }).catch(console.error);
  };

  // --- LIGHT THEME STYLES ---
  const styles = {
    mainBg: {
      background: "#FFFDE7", // Light Yellow Background
      minHeight: "100vh",
      fontFamily: "'Poppins', sans-serif",
      color: "#000",
      paddingBottom: "40px"
    },
    pageHeader: {
      background: "#000",
      color: "#fff",
      padding: "40px 20px 60px",
      borderRadius: "0 0 40px 40px",
      textAlign: "center",
      marginBottom: "20px"
    },
    tabContainer: {
      display: "flex",
      justifyContent: "space-around",
      background: "#fff",
      padding: "6px",
      borderRadius: "20px",
      margin: "-40px 20px 25px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
      border: "1px solid #FFF9C4",
    },
    tabButton: (isActive) => ({
      flex: 1,
      padding: "12px",
      borderRadius: "15px",
      border: "none",
      background: isActive ? "#000" : "transparent",
      color: isActive ? "#FF9800" : "#888",
      fontWeight: "800",
      fontSize: "12px",
      transition: "0.3s",
      textTransform: "uppercase",
      letterSpacing: "0.5px"
    }),
    card: {
      background: "#fff",
      borderRadius: "20px",
      border: "1px solid #FFF9C4",
      padding: "18px",
      marginBottom: "12px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.02)",
    },
    statusBadge: (color) => ({
      fontSize: "10px",
      fontWeight: "800",
      padding: "4px 10px",
      borderRadius: "8px",
      background: `${color}15`,
      color: color,
      border: `1px solid ${color}33`,
      textTransform: "uppercase",
    }),
    amount: (isPositive) => ({
      fontSize: "20px",
      fontWeight: "900",
      color: isPositive ? "#2E7D32" : "#D32F2F",
    }),
    iconBg: (bgColor) => ({
        width: '48px',
        height: '48px',
        borderRadius: '16px',
        background: bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: '20px'
    })
  };

  return (
    <>
      <Header user={user} />
      <div style={styles.mainBg}>
        <div className="container Orher_page_main_section px-0">
          <div className="row justify-content-center m-0">
            <div className="col-lg-6 col-md-10 p-0">
              
              <div style={styles.pageHeader}>
                <h3 className="fw-bold m-0">Activity History</h3>
                <p style={{color: '#888', fontSize: '13px', marginTop: '5px'}}>Track all your gaming and wallet transactions</p>
              </div>

              {/* ==== Premium Tabs ==== */}
              <div style={styles.tabContainer}>
                {["Wallet", "Game", "Penalty", "Bonus"].map((tab) => (
                  <button
                    key={tab}
                    style={styles.tabButton(activeTab === tab)}
                    onClick={() => {
                      setActiveTab(tab);
                      setPageNumber(0);
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              {/* ==== Content Section ==== */}
              <div className="px-3">
                {isLoading ? (
                  <div className="text-center py-5">
                    <Spinner animation="border" style={{color: '#FF9800'}} />
                    <p className="mt-3 text-muted fw-bold">Loading records...</p>
                  </div>
                ) : (
                  <div className="pb-5">
                    {/* WALLET / BONUS / PENALTY RENDER */}
                    {activeTab !== "Game" && (
                      filteredData.length > 0 ? (
                        filteredData.map((item) => {
                          const isPositive = item.Req_type === "deposit" || item.Req_type === "bonus";
                          const statusColor = item.status === "PAID" ? "#2E7D32" : item.status === "Pending" ? "#FF9800" : "#D32F2F";
                          const bgColor = item.Req_type === "deposit" ? "#4CAF50" : item.Req_type === "withdraw" ? "#000" : item.Req_type === "penalty" ? "#f44336" : "#FF9800";
                          const typeIcon = item.Req_type === "deposit" ? <FaArrowDown/> : item.Req_type === "withdraw" ? <FaArrowUp/> : item.Req_type === "penalty" ? <FaExclamationTriangle/> : <FaGift/>;

                          return (
                            <div style={styles.card} key={item._id}>
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <div className="d-flex align-items-center gap-3">
                                  <div style={styles.iconBg(bgColor)}>{typeIcon}</div>
                                  <div>
                                      <h6 className="mb-0 fw-bold text-uppercase" style={{fontSize: '15px', color: '#000'}}>{item.Req_type}</h6>
                                      <small style={{color: '#888', fontWeight: '600'}}>{dateFormat(item.createdAt)}</small>
                                  </div>
                                </div>
                                <div className="text-end">
                                  <div style={styles.amount(isPositive)}>
                                      {isPositive ? "+" : "-"} ₹{item.amount}
                                  </div>
                                  <div style={styles.statusBadge(statusColor)}>{item.status}</div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-between pt-2 border-top border-light">
                                  <small className="fw-bold" style={{color: '#999'}}>CLOSING: ₹{item.closing_balance || "0"}</small>
                                  <small className="fw-bold" style={{color: '#999'}}>#{item._id.slice(-6).toUpperCase()}</small>
                              </div>
                              {item.reason && <p className="small mt-2 mb-0 fw-bold" style={{color: '#FF9800'}}>Reason: {item.reason}</p>}
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-center py-5">
                          <img src="/images/notransactionhistory.png" width="150" alt="empty" style={{opacity: 0.7}} />
                          <p className="mt-3 fw-bold text-muted">No {activeTab} history found</p>
                        </div>
                      )
                    )}

                    {/* GAME HISTORY RENDER */}
                    {activeTab === "Game" && (
                      gameData.length > 0 ? (
                        gameData.map((game) => {
                          const isWin = game.Winner?._id === user._id;
                          const statusColor = isWin ? "#2E7D32" : "#D32F2F";

                          return (
                            <div style={styles.card} key={game._id}>
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <div className="d-flex align-items-center gap-3">
                                  <div style={styles.iconBg(isWin ? "#2E7D32" : "#000")}><FaGamepad /></div>
                                  <div>
                                      <h6 className="mb-0 fw-bold" style={{color: isWin ? "#2E7D32" : "#000"}}>{isWin ? "WINNER" : "LOST"}</h6>
                                      <small style={{color: '#888', fontWeight: '600'}}>{dateFormat(game.createdAt)}</small>
                                  </div>
                                </div>
                                <div className="text-end">
                                  <div style={styles.amount(isWin)}>
                                      {isWin ? "+" : "-"} ₹{isWin ? game.winnAmount : game.Game_Ammount}
                                  </div>
                                  <div style={styles.statusBadge(statusColor)}>{game.Status}</div>
                                </div>
                              </div>
                              
                              <div className="p-3 rounded-4 bg-light d-flex justify-content-between align-items-center border border-warning border-opacity-10">
                                  <div className="small">
                                      <span className="text-muted fw-bold">VS </span>
                                      <span className="fw-bold text-dark">{game.Accepetd_By && game.Accepetd_By._id === user._id ? game?.Created_by?.Name : game?.Accepetd_By?.Name}</span>
                                  </div>
                                  <Button
                                      size="small"
                                      onClick={() => handleSupport(game?._id)}
                                      style={{ color: "#000", fontSize: "11px", fontWeight: '800', textTransform: 'none' }}
                                      startIcon={<SupportAgentIcon style={{color: '#FF9800'}} />}
                                  >
                                      Report issue
                                  </Button>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-center py-5">
                          <img src="/images/nogamehistory.png" width="150" alt="empty" style={{opacity: 0.7}} />
                          <p className="mt-3 fw-bold text-muted">No game records available</p>
                        </div>
                      )
                    )}
                  </div>
                )}

                {/* ==== PAGINATION ==== */}
                {(activeTab === "Game" ? gamePages : walletPages) > 1 && (
                  <div className="custom-pagination d-flex justify-content-center mt-2 mb-5">
                    <ReactPaginate
                      previousLabel={"<"}
                      nextLabel={">"}
                      breakLabel={"..."}
                      pageCount={activeTab === "Game" ? gamePages : walletPages}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination-container"}
                      activeClassName={"active-page"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Invoice
        pageprint={pageprint}
        handleClose={handleClose}
        show={show}
        printRef={printRef}
        invoice_data={invoiceData}
      />

      <style>{`
        .pagination-container {
            display: flex;
            list-style: none;
            gap: 10px;
            padding: 0;
            margin-bottom: 50px;
        }
        .pagination-container li a {
            background: #fff;
            color: #000;
            padding: 8px 15px;
            border-radius: 12px;
            text-decoration: none;
            font-weight: 800;
            border: 1px solid #FFF9C4;
            cursor: pointer;
            box-shadow: 0 4px 10px rgba(0,0,0,0.02);
        }
        .active-page a {
            background: #000 !important;
            color: #FF9800 !important;
            border-color: #000 !important;
        }
        .pagination-container li.disabled a {
            opacity: 0.3;
            cursor: not-allowed;
        }
      `}</style>
    </>
  );
};

export default Transactionhistory;